module.exports = __webpack_public_path__ + "media/application/images/svgs/loader-c084f172623098e1bf391fc8178a6d53.svg";